/*
 * @Author: hongye yanghongye@jtexpress.com
 * @Date: 2025-12-02 19:18:39
 * @LastEditors: hongye
 * @LastEditTime: 2026-03-13 10:58:09
 * @Description: file content
 */

import { menuConfig } from './menuConfig'
const VITE_COUNTRY = import.meta.env.VITE_COUNTRY
export const getMenus = (stationType?: string): MenuItemIn[] => {
  switch (VITE_COUNTRY) {
    case 'VN':
      return menuConfig.vn;
    case 'ID':
      return menuConfig.id;
    case 'MY':
      if (stationType) {
        return filterMenusByStationType(menuConfig.my, stationType);
      }
      return menuConfig.my;
    case 'SG':
      if (stationType) {
        return filterMenusByStationType(menuConfig.sg, stationType);
      }
      return menuConfig.sg
    case 'PH':
      return menuConfig.ph
    default:
      return menuConfig.default
  }
}

const menus = getMenus()

export type MenuItemIn = {
  id: string | number,
  svgIcon?: string,
  menuName: string,
  parentId: string | number,
  menuUrl?: string,
  stationType?: string[]
  children?: MenuItemIn[]
  icon?: string
}
export const flatMenus = menus.reduce((acc, curr) => {
  if (!curr.children?.length) {
    acc.push(curr)
  } else {
    acc = [...acc, { ...curr, children: [] }, ...curr.children]
  }
  return acc
}, [] as MenuItemIn[])

/**
 * 根据站点类型过滤菜单（支持多级嵌套）
 * @param menus 原始菜单数组
 * @param stationType 站点类型
 * @returns 过滤后的菜单数组
 */
const filterMenusByStationType = (menus: MenuItemIn[], stationType: string): MenuItemIn[] => {
  return menus.reduce((result: MenuItemIn[], item: MenuItemIn) => {
    // 检查当前菜单项是否符合站点类型
    const isItemValid = !item.stationType || item.stationType.includes(stationType);

    if (!isItemValid) {
      return result; // 跳过不符合条件的菜单项
    }

    // 创建新的菜单项副本
    const newItem = { ...item };

    // 递归处理子菜单
    if (newItem.children && newItem.children.length > 0) {
      newItem.children = filterMenusByStationType(newItem.children, stationType);

      // 如果子菜单被过滤后为空，且当前菜单没有链接，则跳过该菜单
      if (newItem.children.length === 0 && !newItem.menuUrl) {
        return result;
      }
    }

    result.push(newItem);
    return result;
  }, []);
}
